import React from "react";
import {
  Info,
  InfoText,
  BoldText,
  Container,
} from "./DashboardSearchInfoStyle";
import MoreInfoIcon from "assets/images/icons/infomore.svg";
import InfoProvisionGuide from "components/common/InfoGuide/InfoProvisionGuide";
import { useSelector, useDispatch } from "react-redux";
import { toggleModal } from "redux/modules/dashboard";

const DashboardDetailInfo = ({ top, left }) => {
  const useDashboard = useSelector((state) => state.dashboard);

  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  var fetchDate = new Date(year, month, day, 10, 30);

  const dispatch = useDispatch();

  function dataDate() {
    const now = new Date();
    if (now > fetchDate) {
      return `${year}.${month}.${now.day}일 기준`;
    } else {
      return `${year}.${month}.${day}일 기준`;
    }
  }

  return (
    <Container>
      {useDashboard.searchList.tot_cnt > 0 ? (
        <BoldText color={"#FF7A00"}>
          {useDashboard.searchList.tot_cnt}개<span>의 검색결과</span>
        </BoldText>
      ) : (
        " "
      )}
      <Info>
        <InfoText>{dataDate()}</InfoText>
        <InfoText>
          정보 제공 안내
          <img
            className="moreinfo-icon"
            src={MoreInfoIcon}
            alt="more info"
            onClick={() => dispatch(toggleModal())}
          />
        </InfoText>
      </Info>
      <InfoProvisionGuide top={top} left={left} />
    </Container>
  );
};

export default DashboardDetailInfo;
